// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Sound2OutlinedSvg from "@fishx/icons-svg/es/asn/Sound2Outlined";
import FishxIcon from '../components/FishxIcon';

var Sound2Outlined = function Sound2Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Sound2OutlinedSvg
  }));
};

Sound2Outlined.displayName = 'Sound2Outlined';
export default React.forwardRef(Sound2Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Sound2Outlined.js
// module id = 4169
// module chunks = 0